import { CheckIcon, DownloadIcon, InfoIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Progress,
  SimpleGrid,
  Text,
  useColorModeValue,
  useDisclosure,
  useToast,
  VStack,
  HStack,
  AspectRatio,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { FaFilePdf } from "react-icons/fa";
// import glass4 from "../../../assets/images/glass19.png";
// import glass6 from "../../../assets/images/glass6.jpg";
// import glass7 from "../../../assets/images/glass7.jpg";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
import Footer from "../footer/Footer";
import download from "../../../assets/pdf/Glass-Door.pdf";
import { useNavigate } from "react-router-dom";
import * as Constants from "../../../constants/Constants";
import axios from "axios";

const MotionBox = motion(Box);



const Download = (props) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedCatalog, setSelectedCatalog] = useState(null);
  const [downloading, setDownloading] = useState({});
  const bgColor = useColorModeValue("#FFFFFF", "#FFFFFF");
  const borderColor = useColorModeValue("#FFFFFF", "#FFFFFF");
  const [hasContactSubmitted, setHasContactSubmitted] = useState(false);
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
    useEffect(() => {
            axios
              .get(Constants.REACT_APP_API_URL + "api/upload/download")
              .then((res) => {
                if (res.data.success) {
                  setImages(res.data.data);
                }
              })
              .catch((err) => console.log(err));
          }, []);
          console.log(images);
const catalogs = [
  {
    id: 1,
    title: "Sliding Doors",
    description: "Complete guide to our glass solutions and installations",
    fileSize: "5.2 MB",
    format: "PDF",
    icon: FaFilePdf,
    path: download,
    color: "#000000",
    preview: images[1]?.image_url,
  },
  {
    id: 2,
    title: "Swing Doors",
    description: "Detailed catalog of our door collections and designs",
    fileSize: "4.8 MB",
    format: "PDF",
    icon: FaFilePdf,
    path: download,
    color: "#FFFFFF",
    preview: images[0]?.image_url,
  },
  {
    id: 3,
    title: "Led Mirror",
    description: "Detailed catalog of our door collections and designs",
    fileSize: "3.2 MB",
    format: "PDF",
    icon: FaFilePdf,
    path: download,
    color: "#800080",
    preview: images[2]?.image_url,
  },
  // {
  //   id: 3,
  //   title: "Installation Guide",
  //   description: "Technical specifications and installation instructions",
  //   fileSize: "3.5 MB",
  //   format: "PDF",
  //   icon: FaFileAlt,
  //   path: "/downloads/installation-guide.pdf",
  //   color: "#800080",
  //   preview: images[1]?.image_url,
  // },
  // {
  //   id: 4,
  //   title: "Product Brochure",
  //   description: "Overview of our latest products and innovations",
  //   fileSize: "2.8 MB",
  //   format: "PDF",
  //   icon: FaFileImage,
  //   path: "/downloads/product-brochure.pdf",
  //   color: "orange",
  //   preview: images[1]?.image_url,
  // },
];
  useEffect(() => {
    const submitted = localStorage.getItem("contactSubmitted");
    if (submitted === "true") setHasContactSubmitted(true);
  }, []);

  // const headingGradient = useColorModeValue(
  //   'linear(to-r, #87CEEB, teal.600)',
  //   'linear(to-r, #87CEEB, teal.400)'
  // );
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] = useHomeHook(props);
  const cardHoverBg = useColorModeValue("#FFFFFF", "#FFFFFF");
  const textColor = useColorModeValue("#000000", "#000000");

  const handlePreview = (catalog) => {
    setSelectedCatalog(catalog);
    onOpen();
  };

  const handleDownload = async (catalog) => {
    if (!hasContactSubmitted) {
      navigate("/contact");
    } else {
      setDownloading((prev) => ({ ...prev, [catalog.id]: true }));
      try {
        const link = document.createElement("a");
        link.href = catalog.path;
        link.download = catalog.path.substring(catalog.path.lastIndexOf("/") + 1);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          title: "Download Started",
          description: `${catalog.title} is being downloaded`,
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "bottom-right",
        });
      } catch (error) {
        toast({
          title: "Download Failed",
          description: "Please try again later",
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "bottom-right",
        });
      } finally {
        setDownloading((prev) => ({ ...prev, [catalog.id]: false }));
      }
    }
  };
  return (
    <Box>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />
      <Box px={{ base: 8, md: 16 }} py={{ base: 12, md: 20 }}>
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <VStack spacing={8} mb={12}>
            <Heading
              as="h1"
              size={{ base: "lg", md: "2xl" }}
              textAlign="center"
              color="#000000"
              // bgGradient="linear(to-r, #87CEEB, #800080)"
              // bgClip="text"
              letterSpacing="tight"
              fontWeight="bold"
              mt={12}
            >
              Download Resources
            </Heading>
            <Text
              fontSize="xl"
              textAlign="center"
              color={textColor}
              maxW="3xl"
              lineHeight="tall"
            >
              Access our comprehensive collection of product catalogs,
              installation guides, and technical documentation to help you make
              informed decisions.
            </Text>
          </VStack>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
            {catalogs.map((catalog) => (
              <MotionBox
                key={catalog.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                // whileHover={{ y: -4 }}
              >
                <Box
                  bg={bgColor}
                  p={8}
                  borderRadius="2xl"
                  boxShadow="lg"
                  border="1px"
                  borderColor={borderColor}
                  height="100%"
                  transition="all 0.3s"
                  _hover={{
                    bg: cardHoverBg,
                    boxShadow: "2xl",
                    borderColor: `${catalog.color}.200`,
                  }}
                >
                  <Flex justify="space-between" align="center" mb={4}>
                    <Icon
                      as={catalog.icon}
                      w={10}
                      h={10}
                      color={"black"}
                      opacity={0.6}
                    />
                    <Badge color={"white"} bg="black" opacity={0.6} fontSize="sm">
                      {catalog.format} • {catalog.fileSize}
                    </Badge>
                  </Flex>
                  <Heading size="md" mb={2} color={"black"} opacity={0.6}>
                    {catalog.title}
                  </Heading>
                  <Text color="#000000" mb={4}>
                    {catalog.description}
                  </Text>
                  <Flex gap={4} mt={6}>
                    <Button
                      leftIcon={<InfoIcon />}
                      // colorScheme={catalog.color}
                      color="black"
                      bg="white"
                      boxShadow= "md"
                      transform= "translateY(-2px)"
                      // variant="outline"
                      onClick={() => handlePreview(catalog)}
                      _hover={{
                        transform: "translateY(-2px)",
                        boxShadow: "md",
                      }}
                    >
                      Preview
                    </Button>
                    <Button
                      leftIcon={downloading[catalog.id] ? ( <CheckIcon /> ) : ( <DownloadIcon /> )}
                      bg="white" 
                      color="black" 
                      boxShadow="md" 
                      colorScheme={catalog.color}
                      isLoading={downloading[catalog.id]}
                      loadingText="Downloading"
                      onClick={() => handleDownload(catalog)}
                      flex={1}
                      _hover={{ boxShadow: "md" }}
                    >
                      Download
                    </Button>
                  </Flex>
                  {downloading[catalog.id] && (
                    <Progress
                      size="xs"
                      isIndeterminate
                      colorScheme={catalog.color}
                      mt={4}
                    />
                  )}
                </Box>
              </MotionBox>
            ))}
          </SimpleGrid>
          <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
            <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(4px)" />
            <ModalContent mx={{ base: 4, md: 0 }}>
              <ModalHeader>
                <HStack>
                  <Icon
                    as={FaFilePdf}
                    color={`${selectedCatalog?.color}.500`}
                  />
                  <Heading size="md">{selectedCatalog?.title}</Heading>
                </HStack>
                <Text fontSize="sm" color="#000000" fontWeight="normal">
                  {selectedCatalog?.description}
                </Text>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <AspectRatio ratio={16 / 9}>
                <Flex
                  height="300px"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="lg"
                  overflow="hidden"
                >
                  <Image
                    src={selectedCatalog?.preview}
                    alt={selectedCatalog?.title}
                    objectFit="contain"
                    maxHeight="100%"
                    borderRadius={"1rem"}
                  />
                </Flex>
                </AspectRatio>
                <Flex justify="space-between" mt={6}>
                  <HStack spacing={4}>
                    <Badge colorScheme={selectedCatalog?.color}>
                      {selectedCatalog?.format}
                    </Badge>
                    <Text fontSize="sm" color="#000000">
                      {selectedCatalog?.fileSize} • {selectedCatalog?.pages}{" "}
                      pages
                    </Text>
                  </HStack>
                  <Button
                    leftIcon={<DownloadIcon />}
                    // colorScheme={selectedCatalog?.color}
                    onClick={() => handleDownload(selectedCatalog)}
                    bg="white" 
                        color="black" 
                        boxShadow="md" 
                        _hover={{
                        boxShadow: "md",
                        bg:"white" 
                      }}
                    isLoading={
                      selectedCatalog && downloading[selectedCatalog.id]
                    }
                  >
                    Download PDF
                  </Button>
                </Flex>
              </ModalBody>
            </ModalContent>
          </Modal>
        </MotionBox>
      </Box>
      <Footer />
    </Box>
  );
};

export default Download;
